/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function validateProductForm(btn) {
  let form = btn.closest('form');

  let valid = true;

  if (form && form.querySelector('.custom-field')) {
    let i = 1;
    form.querySelectorAll('.custom-field').forEach(function (field) {
      let personalized = false;
      if (field.value.length > 0) personalized = true;
      if (field.classList.contains('required') && field.value.length < 1) {
        valid = false;
        field.closest('.field-container').classList.add('error');
      } else if (field.classList.contains('required') && field.classList.contains('select') && field.value == '0') {
        valid = false;
        field.closest('.field-container').classList.add('error');
      } else {
        field.classList.remove('error');
        field.closest('.field-container').classList.remove('error');
      }

      if (personalized) {
        if (form.querySelector('input[name="properties[_personalized_' + i + ']"]') == null) {
          let input = document.createElement("input");
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', 'properties[_personalized_' + i + ']');
          input.setAttribute('value', 'true');
          form.appendChild(input);
        } else {
          form.querySelector('input[name="properties[_personalized_' + i + ']"]').value = 'true';
        }
      }
      i++;
    });
  }

  if(document.querySelector('select[aria-label*="Size"]')) {
    let size = document.querySelector('select[aria-label*="Size"]');
    let size_value = size.value;
    let size_label = size.querySelector('option[value="' + size_value + '"]').innerText;
    if(size_value.toLowerCase().includes('select') || size_label.toLowerCase().includes('select')) {
      valid = false;
      size.closest('.select-wrapper').classList.add('error');
    } else {
      size.closest('.select-wrapper').classList.remove('error');
    }
  }

  return valid;
}

function validateCheckSpelling(btn) {
  let parent = btn.parentNode;
  let valid = false;

  if (parent.querySelector('input[name="check-spelling"]') != null) {
    if (parent.querySelector('input[name="check-spelling"]').checked) {
      valid = true;
    }
  }

  return valid;
}

if (document.querySelector(".Form__Input.custom-field")) {
  document.querySelectorAll(".Form__Input.custom-field").forEach(function (el) {
    el.addEventListener("keyup", (e) => {
      let field = e.target;
      if (field.classList.contains('required') && field.value.length < 1) {
        field.closest('.field-container').classList.add('error');
      } else if (field.classList.contains('required') && field.classList.contains('select') && field.value == '0') {
        field.closest('.field-container').classList.add('error');
      } else {
        field.classList.remove('error');
        field.closest('.field-container').classList.remove('error');
      }
    });
  });

}

if (document.querySelector(".product-form .product-form__add-button")) {
  document.querySelectorAll(".product-form .product-form__add-button").forEach(function (el) {
    el.addEventListener("click", (e) => {
      let valid = validateProductForm(e.target);
      if (!valid) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
  });
}

$(document).on('click', 'label[for="check-spelling"]', function (e) {
  let input = $(this).closest('.check-spelling-container').find('input');
  input.checked = !input.checked;
});
$(document).on('click', '.custom-checkbox .checkmark', function (e) {
  let input = e.target.closest('.check-spelling-container').querySelector('input');
  input.checked = !input.checked;
});

$(function() {
  let h = $('.shopify-section--header').height();
  $('predictive-search-drawer').height(h);
});

$(document).on('click', '.checkout-button', function (e) {
  let valid = validateCheckSpelling(e.target);
  let error = document.querySelector('.error.error-no-kit-in-cart');

  if (!valid) {
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('.check-spelling-container').classList.add('error');
    return false;
  } else {
    document.querySelector('.check-spelling-container').classList.remove('error');

    let data = null
    let _data = e.target.dataset.cart;

    if(_data) data = JSON.parse(_data);

    if (data && typeof data.attributes['_required_packages_in_cart'] != "undefined" && parseInt(data.attributes['_required_packages_in_cart']) > 0) {
      if (error) {
        error.classList.remove('active');
      }
    } else if (window.required_packages_block_checkout) {
      // required package NOT in cart, block checkout
      if (error) {
        e.preventDefault();
        e.stopPropagation();
        error.classList.add('active');
      }
    }

  }
});

// set up a mutation observer to trigger changing cart items prices and images
var observeDOM = (function () {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  return function (obj, callback) {
    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserver) {
      var mutationObserver = new MutationObserver(callback)

      mutationObserver.observe(obj, {childList: true, subtree: true})
      return mutationObserver
    } else if (window.addEventListener) {
      obj.addEventListener('DOMNodeInserted', callback, false)
      obj.addEventListener('DOMNodeRemoved', callback, false)
    }
  }
})()

observeDOM(document.querySelector('cart-drawer .drawer__content'), function (m) {
  var addedNodes = [], removedNodes = [];

  m.forEach(record => record.addedNodes.length & addedNodes.push(...record.addedNodes))

  m.forEach(record => record.removedNodes.length & removedNodes.push(...record.removedNodes))

  if (addedNodes.length > 0) {

    fetch("/cart.js")
      .then(response => response.json())
      .then(data => {
        setTimeout(function () {
          // updateCartPricesAndImages(data);
        }, 1000)
      }).catch(error => {
      console.log(error)
    });
  }
});

document.addEventListener('DOMContentLoaded', (e) => {
  updateMultistorePrice();
  updateMultistoreImages();

  document.querySelectorAll('product-item').forEach(item => {
    let input = item.querySelector('input:checked');
    let varId = parseInt(item.dataset.variantId);
    if (input) {
      varId = parseInt(input.dataset.variantId);
    }
    let productId = parseInt(item.dataset.productId);
    let target = item.querySelector('.price');

    updateMultistorePrice(productId, varId, target);

    updateMultistoreImages(null, item);
  });

  fetch("/cart.js")
    .then(response => response.json())
    .then(data => {
      // updateCartPricesAndImages(data);
    }).catch(error => {
    console.log(error)
  });
});

document.addEventListener('cart:refresh', (e) => {
  setTimeout(function () {
    // updateCartPricesAndImages(e.detail.cart);
  }, (e.detail.replacementDelay));

});
document.addEventListener('quick_buy:opened', (e) => {
  let drawer = e.detail.drawer;
  updateMultistoreImages(drawer);
});

document.addEventListener('variant:changed', (e) => {
  let varId = e.detail.variant.id;
  let target = null
  if (typeof e.target != "undefined" && e.target.closest('.drawer__content')) {
    target = e.target.closest('.drawer__content').querySelector('.quick-buy-product__info .price');
    updateMultistoreImages(e.target.closest('quick-buy-drawer'));
  }
  if (typeof e.target != "undefined" && e.target.querySelector('input[name="product_id"]')) {
    let productId = parseInt(e.target.querySelector('input[name="product_id"]').value);
    updateMultistorePrice(productId, varId, target);
  }
});

document.querySelectorAll('.color-swatch-list .color-swatch').forEach(el => {
  el.addEventListener('click', (e) => {
    if (typeof e.target != "undefined") {
      let item = e.target.closest('.product-item');
      if (item) {
        let varId = parseInt(e.target.dataset.variantId);
        let productId = parseInt(item.dataset.productId);
        let target = item.querySelector('.price');
        updateMultistorePrice(productId, varId, target);
        setTimeout(function () {
          updateMultistoreImages(null, item);
        }, 100);
      }
    }
  });
});

// function updateCartPricesAndImages(cart) {
//   let items = cart.items;
//   let prices = window.multistore_prices;

//   if (!items || !prices) return;

//   let total = 0;
//   let i = 0;
//   items.forEach(item => {
//     // Skip kit child items (not the parent/master)
//     if(item.properties.hasOwnProperty('_required_package_item') && !item.properties.hasOwnProperty('_required_package_master_product') && !item.properties.hasOwnProperty('_bundle_data')) {
//       return;
//     }
//     let target = null;
//     target = document.querySelectorAll('cart-drawer .line-item')[i];
//     let productId = item.product_id;
//     let varId = item.variant_id;

//     let _price = prices[productId][varId].multistore_price > 0 ? prices[productId][varId].multistore_price : prices[productId][varId].original_price;
//     let price = ((_price * item.quantity) / 100).toFixed(2);

//     total += _price * item.quantity;

//     // if (target) {
//     //   target.querySelectorAll('.price').forEach(el => {
//     //     el.innerText = '$' + price;
//     //   });
//     // }

//     i++;
//   });

//   // let totalTarget = document.querySelector('cart-drawer .checkout-button ._total');
//   // if (totalTarget) {
//   //   totalTarget.innerText = '$' + (total / 100).toFixed(2);
//   // }
// }

// Update all product prices with multistore prices, if defined
function updateMultistorePrice(productId = null, varId = null, target = null) {
  let prices = window.multistore_prices;

  if (target) {
    if (!productId && typeof target.closest('product-item').dataset.productId != "undefined") {
      productId = target.closest('product-item').dataset.productId;
    }
    if (!varId && typeof target.closest('product-item').dataset.variantId != "undefined") {
      varId = target.closest('product-item').dataset.variantId;
    }
  }

  if (typeof prices == "undefined" || (!varId && !document.querySelector('.product__info .shopify-product-form input[name="id"]'))) return;

  if (!varId) varId = parseInt(document.querySelector('.product__info .shopify-product-form input[name="id"]').value);
  if (!productId) productId = parseInt(document.querySelector('.product__info .shopify-product-form input[name="product_id"]').value);
  if (!target) target = document.querySelector('.product-meta__price-list-container .price');

  if (typeof prices[productId] != "undefined" && typeof prices[productId][varId] != "undefined" && typeof prices[productId][varId].multistore_price != "undefined" && prices[productId][varId].multistore_price > 0) {
    let price = (prices[productId][varId].multistore_price / 100).toFixed(2);

    target.innerText = '$' + price;
  } else if (typeof prices[productId] != "undefined" && typeof prices[productId][varId] != "undefined" && typeof prices[productId][varId].original_price != "undefined" && prices[productId][varId].original_price > 0) {
    let price = (prices[productId][varId].original_price / 100).toFixed(2);

    target.innerText = '$' + price;
  }
}

// Update product images with multistore images, if defined
function updateMultistoreImages(drawer = null, item = null) {
  let productId = null;
  if (drawer) {
    if (!drawer.querySelector('.product-form input[name="product_id"]')) return;
    productId = parseInt(drawer.querySelector('.product-form input[name="product_id"]').value);
  } else if (item) {
    productId = parseInt(item.dataset.productId);
  } else {
    if (!document.querySelector('.product__info .shopify-product-form input[name="product_id"]')) return;
    productId = parseInt(document.querySelector('.product__info .shopify-product-form input[name="product_id"]').value);
  }
  if (!productId) return;

  let images = window.multistore_images[productId];
  if (typeof images == "undefined" || Object.keys(images).length < 1) return;

  let variantImages = window.multistore_variant_images[productId];
  let originalVariantImages = window.original_variant_images[productId];
  let productMedia = window.product_media[productId];
  let image = null;
  let variantImage = null;

  if (images.hasOwnProperty(window.location.host)) {
    image = images[window.location.host];
  }

  // loop product media
  // find variant metafield image for each media ID
  // if not found, find product metafield image
  let doneMediaIds = [];
  for (const [varId, value] of Object.entries(variantImages)) {

    if (variantImages[varId].hasOwnProperty(window.location.host)) {
      variantImage = variantImages[varId][window.location.host];
    }

    let img = null;
    if (image) img = image;
    if (variantImage) img = variantImage;

    if (originalVariantImages.hasOwnProperty(varId) && img) {
      let targetMediaId = originalVariantImages[varId];
      doneMediaIds.push(targetMediaId)

      let target = null;
      let targetThumb = null;
      let targetSwatch = document.querySelector('.image-swatch[data-media-id="'+targetMediaId+'"] img');

      if (drawer) {
        target = drawer.querySelector('.quick-buy-product__image');
      } else if (item) {
        target = item.querySelector('.product-item__primary-image:not([hidden]),.product-item__secondary-image:not([hidden])');
      } else {
        target = document.querySelector('.product__media-item[data-media-id="' + targetMediaId + '"] img');
        targetThumb = document.querySelector('.product__thumbnail-item[data-media-id="' + targetMediaId + '"] img');
      }

      if (target) {
        target.setAttribute('src', img);
        target.removeAttribute('srcset');
      }
      if (targetThumb) {
        targetThumb.setAttribute('src', img);
        targetThumb.removeAttribute('srcset');
      }
      if (targetSwatch) {
        targetSwatch.setAttribute('src', img);
        targetSwatch.removeAttribute('srcset');
      }
    }
  }

  if (!drawer && !item) {
    for (const [mediaId, value] of Object.entries(productMedia)) {
      if (!doneMediaIds.includes(parseInt(mediaId)) && image) {
        let target = document.querySelector('.product__media-item[data-media-id="' + mediaId + '"] img');
        target.setAttribute('src', image);
        target.removeAttribute('srcset');

        let targetThumb = document.querySelector('.product__thumbnail-item[data-media-id="' + mediaId + '"] img');
        targetThumb.setAttribute('src', image);
        targetThumb.removeAttribute('srcset');
      }
    }
  }
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// document.addEventListener('DOMContentLoaded', (e) => {
//   const bundleMetadata = sessionStorage.getItem('bundle_metadata');
//   const metadata = bundleMetadata ? JSON.parse(bundleMetadata) : { kit_id: null };
//   if (metadata.kit_id == null) {
//     document.querySelector('body').classList.remove('required-package-initialized');
//   }
// });


// Update line item properties with the current store ID, from the cart attributes.
// This is used for the custom carrier at checkout.
const lineItemStoreIdSetter = {

  bound: false,
  running: false,

  log: function () {
    if (window.location.hash == "#enable-lisis-debug") {
      console.log('lineItemStoreIdSetter:', ...arguments)
    }
  },

  init: function () {
    if (this.bound) {
      return;
    }
    this.bound = true;

    let _this = this;
    document.addEventListener("cart:ready", (e) => {
      _this.log('trigger:', "cart:ready")
      _this.run();
    });
    document.addEventListener("cart:updated", (e) => {
      _this.log('trigger:', "cart:updated")
      _this.run();
    });
    // This is nearly always what triggers it, as we get redirected to the cart page after adding a product
    fetch('/cart.js').then(res => res.json()).then(cartData => {
      let storeId = cartData.attributes._store_id ?? null;
      _this.log("storeId on load:", storeId);
      if (storeId) {
        _this.log("calling run:")
        _this.run();
      }
    })

  },

  run: function () {
    this.log("run called", this.running)
    if (!this._running) {
      this.log("starting run")
      this.running = true;
      let _this = this;
      fetch('/cart.js').then(res => res.json()).then(cartData => {
        _this.log("cart.js came back...")
        let storeId = cartData.attributes._store_id ?? null;
        _this.log({storeId});

        if (!storeId) {
          return
        }


        let changePromises = cartData.items.filter((item) => {
          return (item.properties._store_id ?? null) != storeId
        }).map((item) => {
          let newProperties = {
            ...item.properties,
            _store_id: storeId
          };
          return () => new Promise((resolve) => {
            _this.log("Property update promise " + item.key)
            fetch('/cart/change.js', {
              'method': 'POST',
              'headers': {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({id: item.key, quantity: item.quantity, properties: newProperties})
            })
              .then(res => res.json())
              .then(data => {
                resolve(data)
              });
          })
        })

        if (changePromises.length) {
          _this.log("Updating " + changePromises.length + " items...");
          Promise.all(
            changePromises.map(promise => promise().then(() => {
              _this.log('[1 cart item updated]')
            }))
          ).then(() => {
            _this.log("All items updated - done")
            _this.running = false;
          })
        } else {
          _this.log("Nothing to update - done")
          _this.running = false;
        }


      }).catch((e) => {
        _this.log("error (- done)", e)
        _this.running = false;
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', lineItemStoreIdSetter.init());


$(document).on('DOMSubtreeModified', '.template-collection .ais-page .ais-hits-container', (e) => {
  if(document.querySelector('.template-collection .ais-page .ais-hits-container .ais-hit-empty')) {
    document.querySelector('.template-collection .ais-page .ais-facets').remove();
    document.querySelector('.template-collection .ais-page .ais-Stats').classList.add('hidden');
    document.querySelector('.template-collection .ais-page .ais-block').style.width = '100%';
  }
});
$(document).on('DOMSubtreeModified', '.template-search .ais-page .ais-hits-container', (e) => {
  if(document.querySelector('.template-search .ais-page .ais-hits-container .ais-hit-empty')) {
    document.querySelector('.template-search .ais-page .ais-facets').remove();
    document.querySelector('.template-search .ais-page .ais-Stats').classList.add('hidden');
    document.querySelector('.template-search .ais-page .ais-block').style.width = '100%';
  }
});

if(document.querySelector('select[aria-label="Size"]')) {
  document.querySelectorAll('select[aria-label="Size"]').forEach((el) => {
    el.addEventListener('change', (e) => {
      validateProductForm(el);
    });
  })
}